/**
 * A conversation Freshdesk deleted or marked spam.
 *
 * The Freshdesk mirror (supabase/functions/ucc-fd-reconciler) sets comm_tickets.deleted / comm_tickets.spam for such
 * conversations. The work lists and counts leave them out. History views (a customer's or a booking's tickets, the
 * search palette) still show them, but with this label in place of their status, so a dead conversation never reads
 * as "Open" work.
 */
export interface FreshdeskMirrorMarks {
  deleted?: boolean | null;
  spam?: boolean | null;
}

/** The plain label for a marked conversation, or null when it carries neither mark. Deleted wins over spam. */
export function freshdeskMarkLabel(row: FreshdeskMirrorMarks | null | undefined): string | null {
  if (row?.deleted === true) return 'Deleted in Freshdesk';
  if (row?.spam === true) return 'Spam in Freshdesk';
  return null;
}
